export default class WPPaginaModel {
  public id: string = "";
  public date: Date = new Date();
  public titulo: string = "";
  public conteudo: string = "";

  public static toModel(obj: any): WPPaginaModel {
    return {
      id: obj.id,
      date: new Date(Date.parse(obj.data)),
      titulo: obj.titulo,
      conteudo: obj.conteudo,
    } as WPPaginaModel;
  }
}
